import { useMemo } from 'react';
import { useEditorStore } from '~/shell/Store';
import { useSequenceStore } from '~/training/sequence/SequenceStore';

export enum ChatState {
  START = 'start',
  CHAT = 'chat',
  EDITOR_FORM = 'editor_form',
  EDITOR_WITH_BOT = 'editor_with_bot'
}

export const useChatState = (id: string, hasCreatedBots: boolean) => {
  const { contentEditable } = useEditorStore();
  const { chatStarted } = useSequenceStore();

  const isChatStarted = chatStarted[id] || false;

  const currentState = useMemo(() => {
    if (contentEditable) {
      return hasCreatedBots ? ChatState.EDITOR_WITH_BOT : ChatState.EDITOR_FORM;
    }
    return isChatStarted ? ChatState.CHAT : ChatState.START;
  }, [contentEditable, hasCreatedBots, isChatStarted]);

  return {
    isChatStarted,
    currentState
  };
};
